import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

import Contacts from './components/Contacts';
import SubmitButton from './components/SubmitButton';
import ErrorNotification from './components/ErrorNotification';
import SuccessNotification from './components/SuccessNotification';

class Form extends React.Component {
    state = {
        form: {
            name: '',
            company: '',
            email: '',
            subject: '',
        },
        isSubmitDisabled: false,
        isLoading: false,
        showForm: true,
        showSuccess: false,
        showError: false,
    };

    render() {
        const {
            form,
            showSuccess,
            showError,
            showForm,
            isLoading,
        } = this.state;
        const { intl } = this.props;

        if (showSuccess) {
            return <SuccessNotification />;
        }

        return (
            <div style={{ marginTop: '2rem' }}>
                {showForm && (
                    <div>
                        <h5 className="title is-5">
                            <FormattedMessage id="conferenceProgramForm.formTitle" />
                        </h5>
                        <Contacts
                            intl={intl}
                            form={form}
                            onChange={this.handleChange}
                            style={{ marginBottom: '1rem' }}
                        />
                        {showError && (
                            <ErrorNotification
                                onClose={this.hideErrorMessage}
                            />
                        )}
                        <div className="is-flex">
                            <SubmitButton
                                onClick={this.handleSubmit}
                                disabled={this.isSubmitDisabled()}
                                isLoading={isLoading}
                                style={{
                                    marginTop: '1rem',
                                    marginLeft: 'auto',
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ form: { ...this.state.form, [name]: value } });
    };

    handleSubmit = () => {
        this.setState({
            isSubmitDisabled: true,
            isLoading: true,
            showError: false,
        });

        let error = false;

        this.sendForm()
            .then((response) => {
                if (response.ok) {
                    this.setState({
                        showSuccess: true,
                        showForm: false,
                        isLoading: false,
                    });
                } else {
                    error = true;
                    this.setState({
                        showError: true,
                        isSubmitDisabled: false,
                        isLoading: false,
                    });
                }
                return response.text();
            })
            .then((data) => error && console.log(data))
            .catch((err) => {
                this.setState({
                    showError: true,
                    isSubmitDisabled: false,
                    isLoading: false,
                });
                console.log(err);
            });
    };

    sendForm = () => {
        const { form } = this.state;

        return fetch('/.netlify/functions/conferenceProgram', {
            method: 'post',
            body: JSON.stringify({
                contacts: form,
            }),
        });
    };

    isSubmitDisabled = () => {
        const { form, isSubmitDisabled } = this.state;
        return (
            isSubmitDisabled ||
            !!Object.keys(form).filter((key) => !form[key]).length
        );
    };
}

export default injectIntl(Form);



// WEBPACK FOOTER //
// ./src/components/ConferenctProgramForm/index.js